module.exports = __webpack_public_path__ + "img/sld_scb_8_t1_red.348e33b8.svg";